<template>
	<v-simple-table dense>
		<thead v-bind='headerProps'>
			<tr>
				<th class='py-2 font-weight-bold rounded-tl-xl'>
					<font-awesome-icon icon='clock' />
				</th>
				<th v-if='displayColumns.pickOne' class='font-weight-bold table-column'>
					P1
				</th>
				<th v-if='displayColumns.pickTwo' class='font-weight-bold table-column'>
					Pick 2
				</th>
				<th v-if='displayColumns.cashThree' class='font-weight-bold table-column'>
					Pick 3
				</th>
				<th v-if='displayColumns.pickFour' class='font-weight-bold table-column'>
					Pick 4
				</th>
				<th v-if='displayColumns.first && displayColumns.second && displayColumns.third'
						class='font-weight-bold rounded-tr-xl table-column'>
					LOT
				</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for='result in computedResults' :key='`${result.date}-${result.time}`'>
				<td class='border-right font-weight-bold'>
					<span v-for="(namePart, index) in result.sortition.abbreviation.split(' ')"
								:key="[namePart,index].join('-')"
								class='sortition-name d-block'
								:class="{'red--text': namePart.includes('P.M')}">{{ namePart }}</span>
				</td>
				<td v-if='displayColumns.pickOne' class='border-right'>
					<digit-image-display class='d-flex justify-center' :digit='result.pickOne' />
				</td>
				<td v-if='displayColumns.pickTwo' class='border-right'>
					<digit-image-display class='d-flex justify-center' :digit='result.pickTwo' />
				</td>
				<td v-if='displayColumns.cashThree' class='border-right'>
					<digit-image-display class='d-flex justify-center' :digit='result.cashThree' />
				</td>
				<td v-if='displayColumns.pickFour' class='border-right'>
					<digit-image-display class='d-flex justify-center' :digit='result.pickFour' />
				</td>
				<td v-if='displayColumns.first && displayColumns.second && displayColumns.third'>
					<div class='d-flex'>
						<digit-image-display display-as-one :digit='result.first' />
						<digit-image-display display-as-one :digit='result.second' />
						<digit-image-display display-as-one :digit='result.third' />
					</div>
				</td>
			</tr>
		</tbody>
	</v-simple-table>
</template>

<script>
import DigitImageDisplay from '@homepage/components/DigitImageDisplay.vue';

export default {
	name: 'ResultsTable',
	components: { DigitImageDisplay },
	props: {
		results: {
			type: Array,
			required: true
		},
		headerProps: {
			type: Object,
			required: false,
			default: () => ({})
		},
		limit: {
			type: Number,
			required: false,
			default: null
		}
	},
	watch: {
		'computedResults': {
			handler(results) {
				this.displayColumns = results.reduce((displayColumns, currentResult) => {
					const { first, second, third, pickOne, pickTwo, cashThree, pickFour } = currentResult;
					displayColumns.first = displayColumns.first || typeof (first) !== 'undefined';
					displayColumns.second = displayColumns.second || typeof (second) !== 'undefined';
					displayColumns.third = displayColumns.third || typeof (third) !== 'undefined';
					displayColumns.pickOne = displayColumns.pickOne || typeof (pickOne) !== 'undefined';
					displayColumns.pickTwo = displayColumns.pickTwo || typeof (pickTwo) !== 'undefined';
					displayColumns.cashThree = displayColumns.cashThree || typeof (cashThree) !== 'undefined';
					displayColumns.pickFour = displayColumns.pickFour || typeof (pickFour) !== 'undefined';

					return displayColumns;
				}, { ...this.displayColumns });
			},
			immediate: true
		}
	},
	computed: {
		computedResults() {
			if (this.limit) {
				return this.results.slice(0, this.limit);
			}

			return this.results;
		}
	},
	data() {
		return {
			displayColumns: {
				first: false,
				second: false,
				third: false,
				pickOne: false,
				pickTwo: false,
				cashThree: false,
				pickFour: false
			}
		};
	}
};
</script>

<style scoped lang='scss'>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
	padding: 0;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
	text-align: center;
}

.border-right {
	border-right: 2px solid black;
}

.sortition-name {
	font-size: 100%;
	font-weight: 800;
	white-space: nowrap;
	margin: 0 2px;
}
</style>
